import { createSlice } from '@reduxjs/toolkit'

const SearchStatus = Object.freeze({
    LOADING: 'LOADING',
    SUCCESS: 'SUCCESS',
    FAILURE: 'FAILURE',
})

const initialState = {
    results: [],
    status: SearchStatus.LOADING,
    errorMessage: null,
    paging: {
        pageNo: 1,
        pageSize: 10,
        pageCount: 1,
        totalRecordCount: 1,
    },
}

const searchSlice = createSlice({
    name: 'search',
    initialState,
    reducers: {
        getSearchResultsRequest: state => {
            state.status = SearchStatus.LOADING
        },
        getSearchResultsRequestSuccess: (state, action) => {
            state.results = action.payload.data
            state.paging = action.payload.paging
            state.status = SearchStatus.SUCCESS
        },
        getSearchResultsRequestError: (state, action) => {
            state.status = SearchStatus.FAILURE
            state.errorMessage = action.payload
        },
    },
})

const {
    getSearchResultsRequest,
    getSearchResultsRequestSuccess,
    getSearchResultsRequestError,
} = searchSlice.actions

export const searchActions = {
    getSearchResultsRequest,
    getSearchResultsRequestSuccess,
    getSearchResultsRequestError,
}

export const searchSelectors = {
    results: state => state.search.results,
    isFetching: state => state.search.status === SearchStatus.LOADING,
    hasError: state => state.search.status === SearchStatus.FAILURE,
    errorMessage: state => state.search.errorMessage,
    paging: state => state.search.paging,
}

const searchReducer = searchSlice.reducer

export default searchReducer
